/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetImportsTableOperationHeadingStyles = makeStyles(theme => ({
  cell: {
    height: 'auto',
    paddingTop: '10px',
    paddingBottom: '10px',
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
    textTransform: 'uppercase',
    fontWeight: 500,
    borderBottomWidth: '2px',
  },
}));
